import { Vehicle } from 'src/entities/dispatch';

export type VehicleInfoRow = { label: string; value: string };

/**
 * 詳細パネルに出す車両情報をラベル付きの行に組み立てる。
 * サンプル (route-planner: components/dispatch/DispatchDetailPanel.tsx:470-481) と同じ
 * 「運送会社 / 車両名 / 車番 / ドライバー」の 4 行。
 *
 * 車番は plateNumber。vehicleNumber は後方互換で truckName が入るため
 * (entities/dispatch.ts:124)、そちらを使うと車両名が二重に出る。
 */
export function buildVehicleInfoRows(vehicle: Vehicle | null | undefined): VehicleInfoRow[] {
  if (!vehicle) return [];

  const candidates: VehicleInfoRow[] = [
    { label: '運送会社', value: vehicle.companyName },
    { label: '車両名', value: vehicle.truckName },
    { label: '車番', value: vehicle.plateNumber },
    { label: 'ドライバー', value: vehicle.driverName },
  ];

  // ラベルだけの行は情報にならないので畳む
  return candidates.filter((row) => (row.value ?? '').trim() !== '');
}
